var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.listeners = new Map();
    }
    EventEmitter.prototype.on = function (type, handler) {
        if (!this.listeners.has(type)) {
            this.listeners.set(type, new Set());
        }
        this.listeners.get(type).add(handler);
        return this;
    };
    EventEmitter.prototype.off = function (type, handler) {
        var _a;
        if (!handler) {
            this.listeners.delete(type);
        }
        else {
            (_a = this.listeners.get(type)) === null || _a === void 0 ? void 0 : _a.delete(handler);
        }
        return this;
    };
    EventEmitter.prototype.once = function (type, handler) {
        var _this = this;
        var wrapper = function (e) {
            _this.off(type, wrapper);
            handler(e);
        };
        return this.on(type, wrapper);
    };
    EventEmitter.prototype.emit = function (type, event) {
        var e_1, _a;
        var handlers = this.listeners.get(type);
        if (!handlers || handlers.size === 0)
            return false;
        try {
            for (var handlers_1 = __values(handlers), handlers_1_1 = handlers_1.next(); !handlers_1_1.done; handlers_1_1 = handlers_1.next()) {
                var handler = handlers_1_1.value;
                handler(event);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (handlers_1_1 && !handlers_1_1.done && (_a = handlers_1.return)) _a.call(handlers_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return true;
    };
    EventEmitter.prototype.hasListeners = function (type) {
        var e_2, _a;
        var _b, _c;
        if (type)
            return ((_c = (_b = this.listeners.get(type)) === null || _b === void 0 ? void 0 : _b.size) !== null && _c !== void 0 ? _c : 0) > 0;
        try {
            for (var _d = __values(this.listeners.values()), _e = _d.next(); !_e.done; _e = _d.next()) {
                var set = _e.value;
                if (set.size > 0)
                    return true;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return false;
    };
    EventEmitter.prototype.removeAllListeners = function () {
        this.listeners.clear();
    };
    return EventEmitter;
}());
export { EventEmitter };
export function createEvent(type, target, originalEvent, x, y, worldX, worldY, payload) {
    var state = { stopped: false };
    var event = {
        type: type,
        target: target,
        currentTarget: target,
        originalEvent: originalEvent,
        x: x,
        y: y,
        worldX: worldX,
        worldY: worldY,
        payload: payload,
        preventDefault: function () {
            var _a;
            (_a = originalEvent.preventDefault) === null || _a === void 0 ? void 0 : _a.call(originalEvent);
        },
        stopPropagation: function () {
            state.stopped = true;
        },
        get propagationStopped() {
            return state.stopped;
        },
    };
    return event;
}
